import { Module, Commit } from "vuex"
import { RootState } from "@/store"

export interface AuthState {
  user: any | null
}

const state: AuthState = {
  user: null,
}

const mutations = {
  setUser(state: AuthState, user: any) {
    state.user = user
  },
}

const getters = {
  user: (state: AuthState) => state.user,
  isAuthenticated: (state: AuthState) => !!state.user,
}

const actions = {
  updateUser({ commit }: { commit: Commit }, user: any) {
    commit("setUser", user)
  },
}

const auth: Module<AuthState, RootState> = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}

export default auth
